module.exports = __webpack_public_path__ + "media/images/category/health-91f7108e410351160fdd2cc3808637fd.jpg";